import { mobileGameConfigs } from '../core/pixi/config';

export const setScreenResolution = (target) => {
  const { innerHeight } = window;
  const height = innerHeight - 30;

  if (target) {
    target.style.transform = `scale(${height / mobileGameConfigs.height})`;
  }
};
